export class Delegate {


    idDelegate: number;
    uid:string;
    nom: string;
    position: any;
    mail: string;
    tel: string;
    mobile:string;
    entreprise: string;
    description: string;
    typeBadge: string;
    frais: number;
    idClient: number;
    note: string;
    pays: string;
  ordre: number;
  dateImpression:Date;
 status:string;
}